export default __webpack_public_path__ + "static/media/olb-halfscreen.8a6d4d84.jpg";